import $ from 'jquery';

let $document,
    $scrollEl,
    scrollTo = 0,
    paddingTop = 38;

init();

export default function ({el, scrollEl}) {
    $(el).on('click', onClick);
    $scrollEl = $(scrollEl);
}

function onClick(e) {
    e.preventDefault();
    $scrollEl.addClass('top');
    scrollTo = $scrollEl.offset().top - paddingTop;
    scrollUp();
}


function init() {
    $document = $(document);

    if (!window.requestAnimationFrame) { // hack for ie9
        window.requestAnimationFrame = function (callback, element) {
            let currTime = new Date().getTime(),
                timeToCall = Math.max(0, 16 - (currTime - lastTime)),
                id = window.setTimeout(function () {
                    callback(currTime + timeToCall);
                },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
}

function scrollUp() {
    let top = $document.scrollTop();
    window.scrollBy(0, (scrollTo - top + 50) / +10);
    if (window.pageYOffset < scrollTo) {
        requestAnimationFrame(scrollUp);
    }
}


// WEBPACK FOOTER //
// ./modules/buttonDown.js